import { httpsCallable, getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

// Get Firebase Functions instance
const functions = getFunctions();

/**
 * Generate an OAuth state token using server-side storage
 * This is more secure than relying on browser storage for state
 * @returns {Promise<string>} The generated state token
 */
export async function generateServerStateToken() {
  try {
    // Ensure user is authenticated
    const auth = getAuth();
    if (!auth.currentUser) {
      throw new Error('User must be authenticated to generate state token');
    }
    
    // Call the Firebase Function
    const generateOAuthState = httpsCallable(functions, 'generateOAuthState');
    const result = await generateOAuthState();
    
    return result.data.stateToken;
  } catch (error) {
    console.error('Error generating server state token:', error);
    throw error;
  }
}

/**
 * Verify an OAuth state token with the server
 * @param {string} stateToken - The state token to verify
 * @returns {Promise<object>} The verification result
 */
export async function verifyServerStateToken(stateToken) {
  try {
    // Use httpsCallable instead of direct fetch to ensure proper URL formatting and authentication
    const verifyOAuthState = httpsCallable(functions, 'verifyOAuthStateCallable');
    const result = await verifyOAuthState({ state: stateToken });
    
    return result.data;
  } catch (error) {
    console.error('Error verifying server state token:', error);
    throw error;
  }
} 